module.exports = __webpack_public_path__ + "me.811450c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/me.jpg
// module id = RsUm
// module chunks = 1